const baseStyle =
  'flex h-11 rounded-md items-center bg-white font-secondary leading-5 placeholder:text-primary-dark/30 text-sm';

export { baseStyle };
